module.exports = __webpack_public_path__ + "static/media/local_storage.abecad9f.svg";